import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';
import { editSite } from '../actions/SiteMenuActions';

export const EditSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.EditSiteSettings,
  translateName: Messages.editSiteSettings_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => editSite(targetItems)
};
